module.exports = __webpack_public_path__ + "media/4.bd5980d9.wav";